<template>
    <div class="grandDay">
        <p style="text-align: center; color: #1b2a65;">¡Es momento de compartir y celebrar juntos! Te invitamos a nuestra cena navideña:</p>
        <img id="grandia" src="https://firebasestorage.googleapis.com/v0/b/swanmoments-f3801.appspot.com/o/Navidad-skycom%2Fgran-dia.svg?alt=media&token=40bbe6e4-d559-4a2b-bcd4-ac8e1d740b07" alt="">
        <p id="day">{{ moment(gday.FechaHoraEvento, 'DD . MMMM . YYYY') }}</p>
        <img style="width: 10rem;" src="https://firebasestorage.googleapis.com/v0/b/swanmoments-f3801.appspot.com/o/Navidad-skycom%2Fhojitas.svg?alt=media&token=883c9ab9-ff87-4fb9-83e6-07d1b7830e43" alt="">
        <p style="text-align: center;"> {{ gday.TextoIntro }}</p>
        <div class="count">
            <div class="textCount">
                <p>Sólo faltan...</p>
            </div>
            <div class="time">
                <span class="numeros" id="days">0</span>
                <p>Días</p>
            </div>
            <div class="time">
                <span class="numeros" id="hours">0</span>
                <p>Horas</p>
            </div>
            <div class="time">
                <span class="numeros" id="minutes">0</span>
                <p>Minutos</p>
            </div>
            <div class="time">
                <span class="numeros" id="seconds">0</span>
                <p>Segundos</p>
            </div>
        </div>

    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
export default {
    name: 'GrandDay',
    props: {
        Code: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            gday: {
                FechaHoraEvento: "2023-12-15T18:00:00",
                TextoIntro: ""
            }
        }
    },
    methods: {
        moment: function (date, format) {
            var _date = new Date(date.replaceAll("T", " ").replaceAll(".000Z", ""))
            return moment(_date).locale("es-mx").format(`${format}`);
        },

        updateCountdown() {
            var DATE_TARGET = new Date(this.gday.FechaHoraEvento.replaceAll("T", " ").replaceAll(".000Z", ""));
            const SPAN_DAYS = document.querySelector("span#days");
            const SPAN_HOURS = document.querySelector("span#hours");
            const SPAN_MINUTES = document.querySelector("span#minutes");
            const SPAN_SECONDS = document.querySelector("span#seconds");
            // Milliseconds for the calculations
            const MILLISECONDS_OF_A_SECOND = 1000;
            const MILLISECONDS_OF_A_MINUTE = MILLISECONDS_OF_A_SECOND * 60;
            const MILLISECONDS_OF_A_HOUR = MILLISECONDS_OF_A_MINUTE * 60;
            const MILLISECONDS_OF_A_DAY = MILLISECONDS_OF_A_HOUR * 24;

            // Calcs
            var NOW = new Date();
            var DURATION = DATE_TARGET - NOW;
            const REMAINING_DAYS = Math.floor(DURATION / MILLISECONDS_OF_A_DAY);
            const REMAINING_HOURS = Math.floor(
                (DURATION % MILLISECONDS_OF_A_DAY) / MILLISECONDS_OF_A_HOUR
            );
            const REMAINING_MINUTES = Math.floor(
                (DURATION % MILLISECONDS_OF_A_HOUR) / MILLISECONDS_OF_A_MINUTE
            );
            const REMAINING_SECONDS = Math.floor(
                (DURATION % MILLISECONDS_OF_A_MINUTE) / MILLISECONDS_OF_A_SECOND
            );

            // Render
            if (
                (SPAN_DAYS != null) &
                (SPAN_HOURS != null) &
                (SPAN_MINUTES != null) &
                (SPAN_SECONDS != null)
            ) {
                SPAN_DAYS.textContent = REMAINING_DAYS;
                SPAN_HOURS.textContent = REMAINING_HOURS;
                SPAN_MINUTES.textContent = REMAINING_MINUTES;
                SPAN_SECONDS.textContent = REMAINING_SECONDS;
            }
        },

        GetGrandDay() {
            let url = process.env.VUE_APP_API_DEV ? `${process.env.VUE_APP_API_DEV}Event/GetGrandDay/${this.Code}` : `${process.env.VUE_APP_API_PRO}Event/GetGrandDay/${this.Code}`;
            axios.get(url)
                .then((response) => this.gday = response.data)
                .catch(err => console.error(err));
        }
    },
    created() {
        setInterval(this.updateCountdown, 1000);
        this.GetGrandDay();
    },
    mounted() {
        setInterval(this.updateCountdown, 100);
    },
    updated() {
        this.updateCountdown();
        setInterval(this.updateCountdown, 100);
    },

}
</script>

<style scoped>
.grandDay {
    display: grid;
    grid-template-columns: 1fr;
    grid-column-gap: 0px;
    grid-row-gap: 1rem;
    place-items: center;
    color: var(--txt);
}


.count {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-template-rows: 1fr;
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    place-items: center;
    border-color: #0076e6;
    border: solid 2px;
    height: 10rem;
    color: #0076e6;
}


span.numeros {
    font-size: 2rem;
    font-family: var(--titulos);

}

#day {
    font-size: 2rem;
    font-family: var(--titulos);
    color: #1b2a65;
}

.time {
    text-align: center;
}

.textCount {
    text-align: center;
    background-color: #0076e6;
    height: 100%;
    width: 100%;
    color: #fff;
    display: grid;
    align-items: center;

    & p {
        font-family: 'Gwendolyn' !important;
        font-size: 1.5rem;
    }
}


#grandia{
    width: 5rem;
}


@media (max-width: 768px) {
    #center-flower {
        display: none;
    }

    .count {
        grid-template-rows: 3rem 1fr;
        grid-template-columns: repeat(4, 1fr);
        width: 85%;
    }

    .textCount {
        grid-column: 1 / 5;
    }
    .textCount > p {
        font-size: 2rem !important;
    }
}
</style>
